module.exports = __webpack_public_path__ + "static/media/logo.97a6dd3e.webp";